import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Header from "./Header";
import Sidebar from "./Sidebar";

function Layout({userRole}) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const { user } = useAuth();

  const getRoleClass = () => {
    if (!user?.role) return '';
    return `role-${user.role.toLowerCase()}`;
  };

  return (
    <div className={`h-screen flex flex-col ${getRoleClass()}`}>
      {/* Fixed Header */}
      <header className="fixed top-0 left-0 right-0 z-50">
        <Header onToggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      </header>

      <div className="flex flex-1 pt-[64px] overflow-hidden">
        {/* Fixed Sidebar */}
        <aside
          className={`fixed top-[64px] left-0 h-[calc(100vh-64px)] transition-all duration-300 z-40 ${
            isSidebarOpen ? "w-64" : "w-16"
          }`}
        >
          <Sidebar isOpen={isSidebarOpen} userRole={userRole}/>
        </aside>

        {/* Scrollable Main Content */}
        <main
          className={`flex-1 overflow-y-auto transition-all duration-300 p-6 ${
            isSidebarOpen ? "ml-64" : "ml-16"
          }`}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
